import { Component, Input, Output, EventEmitter } from '@angular/core';
import { expansion } from '@ui-app/animations/expansion';

@Component({
    selector: 'ui-grid-selection',
    templateUrl: './grid-selection.component.html',
    styleUrls: ['./grid-selection.component.less'],
    animations: [expansion],
})
export class GridSelectionComponent {
    @Input() selectionNotificationExpanded: boolean;
    @Input() selectedRequests: number;
    @Input() totalRequests: number;
    @Input() isAllVisibleSelected: boolean;
    @Output() onSelectAllVisible = new EventEmitter<void>();
    @Output() onSelectAll = new EventEmitter<void>();
    @Output() onCancelSelection = new EventEmitter<void>();
}
